export default __webpack_public_path__ + "static/media/icon-faq-question.6dc46d3d.svg";